<template>
  <div class="expend-settings-list">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>房间号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入房间号" v-model="table.search.number"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>房屋属性</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.type" placeholder="请选择房屋属性">
              <a-select-option :value="1">{{houseTypeText(1)}}</a-select-option>
              <a-select-option :value="2">{{houseTypeText(2)}}</a-select-option>
              <a-select-option :value="3">{{houseTypeText(3)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>房屋状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择房屋状态">
              <a-select-option :value="1">{{houseStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{houseStatusText(2)}}</a-select-option>
              <a-select-option :value="3">{{houseStatusText(3)}}</a-select-option>
              <a-select-option :value="4">{{houseStatusText(4)}}</a-select-option>
              <a-select-option :value="5">{{houseStatusText(5)}}</a-select-option>
              <a-select-option :value="6">{{houseStatusText(6)}}</a-select-option>
              <a-select-option :value="7">{{houseStatusText(7)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="expendSettings()">费项设置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanExpendSettings(data)">详情</a-button>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="80%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <expend-settings-detail :id="drawer.id"></expend-settings-detail>
    </a-drawer>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <expend-settings-settings ref="expendSettingsSettings"></expend-settings-settings>
    </a-modal>
  </div>
</template>

<script>
  import {
    houseTypeText,
    houseStatusText
  } from '@/io/dict.js';
  import BuildingService from '@/io/building.js';
  import ExpendSettingsDetail from '@/views/community/ExpendSettingsDetail.vue';
  import ExpendSettingsSettings from '@/views/community/expend_settings/Settings.vue';

  export default {
    name: 'ExpendSettingsList',
    props: {
      communityId: {
        type: Number,
        default: null
      },
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        houseTypeText,
        houseStatusText,
        table: {
          loading: false,
          search: {
            number: null,
            type: [],
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '楼栋',
              dataIndex: 'build.alias'
            },
            {
              title: '单元',
              dataIndex: 'door.alias'
            },
            {
              title: '楼层',
              dataIndex: 'floor.alias'
            },
            {
              title: '房间号',
              dataIndex: 'alias'
            },
            {
              title: '房屋属性',
              dataIndex: 'houseTypeText'
            },
            {
              title: '房屋状态',
              dataIndex: 'houseStatusText'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        drawer: {
          id: null,
          show: false,
          title: '费项详情'
        },
        modal: {
          title: '费项设置',
          show: false
        }
      }
    },
    components: {
      ExpendSettingsDetail,
      ExpendSettingsSettings,
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.searchTable();
          }
        },
        immediate: true
      },
      communityId: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    methods: {
      confirmModal() {
        this.$refs.expendSettingsSettings.submit(() => {
          this.modal.show = false;
        });
      },
      expendSettings() {
        this.modal.show = true;
      },
      scanExpendSettings(data) {
        this.drawer.id = data.id;
        this.drawer.show = true;
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          number: null,
          type: [],
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        BuildingService.houseListPage(
          this.communityId,
          this.id,
          this.table.search.number,
          this.table.search.type,
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.houseTypeText = houseTypeText(val.house_state);
            val.houseStatusText = houseStatusText(val.state);
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>